import styles from './footer.module.scss';
import ig from '../../Assets/Images/Icons/Social/ig.png';

const Footer = () => {
    return (
        <div className={styles.container}>
            <div className={styles.leftBox}></div>

            <div className={styles.middleBox}>
                <h3>Snow & Co.</h3>
                <img src={ig} alt='ig' />
                <p>Copyright © {new Date().getFullYear()} Snow & Co. All rights reserved.</p>
            </div>

            <div className={styles.rightBox}></div>
        </div>
    );
};

export default Footer;
